import { useQuery } from "@tanstack/react-query";
import { getDiscussChatHistoryForDocument } from "../services/discuss.service";

/**
 * Hook to fetch and manage chat history for a document
 */
export const useDiscussHistory = (documentId?: string) => {
  return useQuery({
    queryKey: ["chatHistory", documentId],
    queryFn: () => getDiscussChatHistoryForDocument(documentId ?? ""),
    enabled: !(documentId == null), // Only run the query if documentId is provided
  });
};
